var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.floorWarning)?_c('div',{staticClass:"stl-banner stl-banner-warning"},[_c('i',{staticClass:"fa fa-exclamation-triangle"}),_c('span',[_vm._v(" 총요금과 세대 청구 합계가 일치하지 않습니다 (절삭 잔차 "+_vm._s(_vm.fmtWon(_vm.floorWarning.floorRemainder ?? _vm.floorWarning.diff))+"원). 정책상 잔차 흡수 없음 — 확인 후 확정하세요. ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }